import { StockItem, ItemLegend, Constants } from '@co-assist/library';

export class ItemThumbnail extends StockItem {

    private _langage: string;

    constructor(object: StockItem, lang: string) {
        super(object);
        this._langage = lang;
    }

    set langage(lang: string) {
        this._langage = lang;
    }

    get title() {
        return (this[this._langage] as ItemLegend).title;
    }

    get subtitle() {
        return (this[this._langage] as ItemLegend).subtitle;
    }

}
